import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Input = () => {
  const [fileName, setFileName] = useState("");
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);

  const onChangeFile = (e) => {
    setFileName(e.target.files[0]);
  };

  const handleUpload = (e) => {
    setLoading(true);
    e.preventDefault();

    if (!fileName || !name) {
      setErr(true);
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("uploadImage", fileName);

    fetch(
      "https://shreyas-dobby-backend-production.up.railway.app/api/uploadImg",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        // console.log(result);
        navigate("/");
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="p-5 flex justify-center items-center">
      <div className="bg-slate-300 p-9 flex rounded-lg">
        <form encType="multipart/form-data">
          <div className="space-y-5 mb-5">
            <p>Name</p>
            <input
              type="text"
              name="name"
              placeholder="name"
              className="outline-none p-1 rounded border-2 border-gray-400"
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className="space-y-5">
            <input type="file" name="uploadImage" onChange={onChangeFile} />
          </div>
          <p className="text-sm text-red-600">(png, jpg, jpeg)</p>
          <button
            onClick={handleUpload}
            type="submit"
            className="bg-black text-white rounded-md p-4 mt-5"
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
          {err && <p className="text-red-600 p-2">All fields are required!</p>}
        </form>
      </div>
    </div>
  );
};

export default Input;
